import React from "react";
import NumberDisplay from "../NumberDisplay";
import {TaggedLogger} from "@nextlot/core/utilities";
import {Bid} from "@nextlot/core/webcast/data/data_types_definitions";
import {AuctionsManager} from "@nextlot/core/webcast";
import {useAppSelector} from "@nextlot/core/webcast/hooks";

const _logger = TaggedLogger.get('ClerkBiddingHistoryCmp');


function BiddingHistoryListItem(props:{bid:Bid, isHighestBid:boolean, isInternetBidder:boolean}) {
    return (
        <div className={`bids-history__list-item ${props.isInternetBidder ? 'item--is-internet-bidder' : (props.isHighestBid ? 'item--is-highest-bid' : '')} ${props.bid.overridden ? 'item--is-overridden': ''}`}>
            <div className="value">{NumberDisplay.formatValueCents(props.bid.value)}</div>
            <div className="bidder">{props.bid.bidderDisplay} {props.bid.auto ? '*' : null}</div>
        </div>
    )
}


export default function ClerkBiddingHistoryCmp() {

    const myUserId:number = AuctionsManager.currentWebcastAuctionHandler.auctionConnectData.participantId;
    const bidsHistory = useAppSelector((state) => state.activeWebcast.webcastCurrentRoundBidding.bidsHistory);

    return (
        <div className="bidding-history-card">
            <div className="card-header bg-light">
                Bidding History
            </div>

            <div className="bidding-history__list-container">
                { bidsHistory && bidsHistory.length > 0 &&

                    <div className="bids-history-list">
                        {
                            [... bidsHistory] // clone Array so we do not mutate with .reverse()
                                .reverse()
                                .map((bid, index) => (<BiddingHistoryListItem
                                    key={[bid.value, bid.bidderNo, bid.overridden || '0'].join('_')}
                                    bid={bid}
                                    isHighestBid={index === 0}
                                    isInternetBidder={bid.userId !== myUserId} />))

                        }
                    </div>
                }
            </div>
        </div>
    )
}
